import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { GET_TERM_RECORDS } from "../actions";


import {
  getTermRecordsSuccess,
  getTermRecordsError,
} from "./actions";

export function* watchGetTermRecords() {
  yield takeEvery(GET_TERM_RECORDS, getTermRecordList);
}

const getCurrentPageRecords = (allRecords, pageNumber, pageSize) => {
  let currentPageRecords = [];
  if (Object.keys(allRecords).length > 0) {
    for (var key in allRecords) {
      currentPageRecords.push({
        ...allRecords[key],
        id: key,
      });
    }
  }
  let startIndex = (pageNumber - 1) * pageSize;
  let lastIndex = startIndex + pageSize;
  currentPageRecords = currentPageRecords.slice(
    startIndex,
    currentPageRecords.length >= lastIndex
      ? lastIndex
      : currentPageRecords.length
  );
  return currentPageRecords;
};

const getTermRecordListAsync = async (payload) => {
    try {
      const responseObject = await centralApiAxios.get(`/terms?vocabulary_id=${payload.vocabularyId}`);

        return {
          recordTermList: responseObject.data.items,
          message: null,
        };       
    } catch (error) {
        return {
            message: 'Failed to get contact. ' + error
        }
    }
}


function* getTermRecordList({ payload }) {
  try {
    const recordListReturned = yield call(getTermRecordListAsync, payload);
    if (!recordListReturned.message) {
      let recordListParam = {
        records: getCurrentPageRecords(
          recordListReturned.recordTermList,
          payload.pageNumber,
          5
        ),
        searchText: recordListReturned.searchText,
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize: 5,
          startIndex: (payload.pageNumber - 1) * 5 + 1,
          totalItemCount: Object.keys(recordListReturned.recordTermList).length,
          totalPages: Math.ceil(
            Object.keys(recordListReturned.recordTermList).length / 5
          ),
        },
        responseTime: recordListReturned.responseTime,
      };
      yield put(getTermRecordsSuccess(recordListParam));
    } else {
      yield put(getTermRecordsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getTermRecordsError(error));
  }
}

export default function* rootSaga() {
  yield all([fork(watchGetTermRecords)]);
}